export default "/images/Closed_Hover.svg?bf15d6c34f8eab94920b47c6abed54da";